// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c30c5241","103":"4de65be3","115":"48b377a0","254":"ae1e1200","615":"831548df","627":"95f7c536","702":"688b0b7a","907":"102c1cef","972":"b76f661a"}[chunkId] + ".chunk.js";
};